import { useCallback, useState } from 'react'
import classNames from 'classnames'
import LoadingWrapper from 'components/loading/LoadingWrapper'
import CheckBox from 'components/form/CheckBox'
import { batch, useDispatch, useSelector } from 'react-redux'
import {
  checkBizChannel,
  checkCreativeStatus,
  checkReviewStatus,
  setCheckedAllBizChannels,
} from 'features/creative/list/creativeListFilterSlice'
import { ReviewStatus } from 'features/Codes'
import NoneAnchor from 'components/NoneAnchor'
import Button from 'components/form/Button'
import { clearSelectedIds, fetchCreatives, setPage } from './creativeListSlice'
import useOutsideClick from '../../../utils/hooks/useOutsideClick'

const CreativeListFilter = () => {
  const dispatch = useDispatch()
  const {
    creativeList: { page },
    creativeListFilter: {
      isChannelsLoading,
      filterCreativeStatus,
      filterReviewStatus,
      filterBizChannels,
      checkedAllBizChannels,
    },
  } = useSelector(state => state.creative)
  const [isFilterOpen, setFilterOpen] = useState(false)
  const ref = useOutsideClick(() => setFilterOpen(false))
  const onCheckCreativeStatus = id => dispatch(checkCreativeStatus(id))
  const onCheckReviewStatus = id => dispatch(checkReviewStatus(id))
  const onCheckBizChannel = (id, checked) =>
    dispatch(
      checkBizChannel({
        id,
        checked,
      })
    )
  const onCheckAllBizChannel = () => dispatch(setCheckedAllBizChannels())

  const onApplyFilter = useCallback(() => {
    batch(() => {
      dispatch(clearSelectedIds())
      if (page !== 0) {
        dispatch(setPage(0))
      } else {
        dispatch(fetchCreatives())
      }
      if (filterReviewStatus.every(status => !status.checked)) {
        dispatch(checkReviewStatus(ReviewStatus.REJECTED_APPROVAL.name))
        dispatch(checkReviewStatus(ReviewStatus.APPROVING.name))
        dispatch(checkReviewStatus(ReviewStatus.APPROVED.name))
      }
      if (filterCreativeStatus.every(status => !status.checked)) {
        dispatch(checkCreativeStatus('ON'))
      }
      if (filterBizChannels.every(channel => !channel.checked)) {
        dispatch(setCheckedAllBizChannels())
      }
    })
  }, [
    dispatch,
    page,
    filterReviewStatus,
    filterCreativeStatus,
    filterBizChannels,
  ])

  return (
    <div ref={ref} className="single_wrap">
      <div
        className={classNames('opt_select opt_right', {
          opt_open: isFilterOpen,
          in_active: false,
        })}>
        <div className="screen_out">데이터종류 선택상자</div>
        <span className="screen_out">선택내용 : </span>
        <NoneAnchor
          className={classNames('link_selected', { link_default: false })}
          onClick={() => setFilterOpen(!isFilterOpen)}>
          필터
        </NoneAnchor>
        <span className="ico_arr" />
        <div className="screen_out">선택옵션</div>
        <div className="optlist_row">
          <LoadingWrapper isLoading={isChannelsLoading}>
            <div className="optrow_wrap">
              <div className="optrow_cell">
                <strong className="tit_optrow">운영상태</strong>
                <ul className="list_opt">
                  {filterCreativeStatus.map(status => (
                    <li key={status.id}>
                      <CheckBox
                        id={status.id}
                        name="columCheckSet"
                        label={status.name}
                        checked={status.checked}
                        onCheckedChange={() => onCheckCreativeStatus(status.id)}
                      />
                    </li>
                  ))}
                </ul>
                <strong className="tit_optrow">심사상태</strong>
                <ul className="list_opt">
                  {filterReviewStatus.map(status => (
                    <li key={status.name}>
                      <CheckBox
                        id={status.name}
                        name="columCheckSet"
                        label={status.title}
                        checked={status.checked}
                        onCheckedChange={() => onCheckReviewStatus(status.name)}
                      />
                    </li>
                  ))}
                </ul>
              </div>
              <div className="optrow_cell channel_cell">
                <strong className="tit_optrow">비즈채널</strong>
                <ul className="list_opt">
                  <li>
                    <CheckBox
                      id="columCheckSet0"
                      name="columCheckSet"
                      label="전체"
                      checked={checkedAllBizChannels}
                      onCheckedChange={onCheckAllBizChannel}
                    />
                  </li>
                </ul>
                <ul className="list_opt">
                  {filterBizChannels.map(({ id, checked, name, siteUrl }) => (
                    <li key={id}>
                      <CheckBox
                        id={id}
                        name="columCheckSet"
                        label={
                          <>
                            <span className="limit_line">{name}</span>
                            {siteUrl.mobileUrl && (
                              <span className="txt_addr">{`${siteUrl.mobileUrl.protocol.toLowerCase()}://${
                                siteUrl.mobileUrl.url
                              }`}</span>
                            )}
                            {siteUrl.pcUrl && (
                              <span className="txt_addr">{`${siteUrl.pcUrl.protocol.toLowerCase()}://${
                                siteUrl.pcUrl.url
                              }`}</span>
                            )}
                          </>
                        }
                        checked={checked}
                        onCheckedChange={() => onCheckBizChannel(id, !checked)}
                      />
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="wrap_btn">
              <Button
                line
                onClick={() => {
                  onApplyFilter()
                  setFilterOpen(!isFilterOpen)
                }}>
                적용
              </Button>
            </div>
          </LoadingWrapper>
        </div>
      </div>
    </div>
  )
}

export default CreativeListFilter
